import AddCostIndex from "@/components/addcost/index.vue";
// import routesDashboard from "@/components/claim/dashboard/routes";
import routesPengajuan from "@/components/addcost/pengajuan/routes";
import routesPenerimaan from "@/components/addcost/penerimaan/routes";
// import routesEmailNotification from "@/components/claim/emailnotification/routes";

export default [
//   {
//     path: "/claim/dashboard-claim",
//     component: ClaimIndex,
//     children: routesDashboard
//   },
  {
    path: "/addcost/pengajuan-addcost",
    component: AddCostIndex,
    children: routesPengajuan
  },
  {
    path: "/addcost/penerimaan-addcost",
    component:  AddCostIndex,
    children:  routesPenerimaan
  },
//   {
//     path: "/claim/emailnotification",
//     component: ClaimIndex,
//     children:  routesEmailNotification
//   }
];
